import graphqlResource, { GraphqlResource } from 'modules/core/graphql-resource';
import { ActiveTournamentPlanDto, ResponseActiveTournamentPlanDto } from '../interfaces/tournament-plan-dto';

export class OrganizersRepository {
  constructor(private readonly graphqlResource: GraphqlResource) {}

  async fetchOrganizerPlan(tournamentId: number): Promise<ActiveTournamentPlanDto | null> {
    const query = `#graphql
      query getTournamentsDetails($tournamentId: Int!) {
        activeTournamentPlan(tournamentId: $tournamentId) {
          id
          name
          priceInMinorUnits
          features {
            id
            featureLimit
            createdAt
            updatedAt
            feature
          }
          createdAt
          updatedAt
          period
        }
      }
    `;

    const response = await this.graphqlResource.query<ResponseActiveTournamentPlanDto>(query, { tournamentId });
    if (response.data?.error) {
      console.debug({ response: response.data?.error });
      return null;
    }

    return response.data.data.activeTournamentPlan;
  }
}

const organizersRepository = new OrganizersRepository(graphqlResource);
export default organizersRepository;
